import * as braze from "@braze/web-sdk";

// MARK: Braze configuration

// Initialize the SDK
braze.initialize(import.meta.env.VITE_APP_BRAZE_KEY, {
  baseUrl: import.meta.env.VITE_APP_BRAZE_BASE_URL,
  enableLogging: true,
});

// Request push permissions
const requestPushPermission = () => {
  try {
    braze.requestPushPermission();
  } catch (e) {
    // ignore
  }
};

// MARK: Braze public actions

// Change the current user
export const brazeChangeUser = (userId?: number) => {
  // optionally set the current user's external ID before starting a new session
  // you can also call `changeUser` later in the session after the user logs in
  if (userId) {
    braze.changeUser(String(userId));
    braze.openSession();
  }
};

// Logs a `push_primer` event that will fire the push-primer in-app message.
export const brazePushAuthorization = () => {
  requestPushPermission();
};
